export default __webpack_public_path__ + "static/media/icon-trophy-empty.b57a2a97.svg";